import { ZorroPyClient } from '../__generatedZorroPy__';

type Options = {
  accessToken?: string;
};

type AgentClientOptions = Options & {
  impersonatedEmployeeId?: string;
};

const buildClient = ({
  accessToken,
  impersonatedEmployeeId,
}: AgentClientOptions): ZorroPyClient => {
  const baseUrl = process.env.NEXT_PUBLIC_ZORRO_PY_BASE_URL;

  if (!baseUrl) {
    throw new Error('NEXT_PUBLIC_ZORRO_PY_BASE_URL not set');
  }

  return new ZorroPyClient({
    BASE: baseUrl,
    TOKEN: accessToken,
    HEADERS: impersonatedEmployeeId
      ? { 'X-Impersonate-Employee-Id': impersonatedEmployeeId }
      : undefined,
  });
};

export const ZorroPyClientFactory = {
  getInstance(options: Options) {
    return buildClient(options).default;
  },

  getAgentShoppingConsultant(options: AgentClientOptions) {
    return buildClient(options).agentShoppingConsultant;
  },
};
